import { render, staticRenderFns } from "./EditRoom.vue?vue&type=template&id=faadd2a8&scoped=true&"
import script from "./EditRoom.vue?vue&type=script&lang=js&"
export * from "./EditRoom.vue?vue&type=script&lang=js&"
import style0 from "./EditRoom.vue?vue&type=style&index=0&id=faadd2a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faadd2a8",
  null
  
)

export default component.exports